/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class CollectionListDirectiveController {

        public static $inject : string[] = ['$scope'];

        public name: string;
        public title: string;
        public collection: any;
        public columns: any;
        public hideHeader: boolean;
        public muteNonDefaultRows: boolean;
        public defaultRowKey: string = 'default';
        public hideSinglePagePager: boolean;
        public showLoadAll: boolean;
        public showExportCsv: boolean;
        public exportFilePrefix: string;
        public exportColumns: any;
        public onLoadingStart: any;
        public onLoadingSuccess: any;
        public onLoadingError: any;
        public onSort: any;
        public parentController: any;
        public rowClasses: any;
        public hideRow: any;

        public customRowTemplate: string;

        constructor(public $scope: any) { }

        public get visibleColumns() : number {
            return $.grep(this.columns, function(c: any) { return !c.hidden; }).length;
        }

        public get hasSortableColumns() : boolean {
            return $.grep(this.columns, function(c: any) { return c.sortable; }).length > 0;
        }

        public handleLoadingStart() : void {
            if (this.onLoadingStart && angular.isFunction(this.onLoadingStart)) {
                this.onLoadingStart();
            }
        }

        public handleLoadingSuccess() : void {
            if (this.onLoadingSuccess && angular.isFunction(this.onLoadingSuccess)) {
                this.onLoadingSuccess();
            }
        }

        public handleLoadingError(response: any) : void {
            if (this.onLoadingError && angular.isFunction(this.onLoadingError)) {
                this.onLoadingError({ response: response });
            }
        }

        public handleSort(column: any) : void {
            column.sortDirection = column.sortDirection === 'desc' ? 'asc' : 'desc';
            this.onSort({ sortBy: column.sortBy || column.key, sortDirection: column.sortDirection });
        }

        public isColumnHidden(column: any) : boolean {
            return typeof column.hidden === 'function' ? column.hidden() : column.hidden;
        }

        public hasCustomRow(index: number) : boolean {
            return this.parentController
                && typeof this.parentController.isActiveCustomRow === 'function'
                && this.parentController.isActiveCustomRow(index);
        }

        public getActionTooltip(action: any, record: any) : string {
            return typeof action.tooltip === 'function' ? action.tooltip(record) : action.tooltip;
        }

        public handleRowClasses (record: any, index: number) {
            if (this.rowClasses && angular.isFunction(this.rowClasses)) {
                return this.rowClasses({ record: record, index: index });
            }
        }

        public handleHideRow (record: any) {
            if (this.hideRow && angular.isFunction(this.hideRow)) {
                return this.hideRow({record: record});
            }
        }
    }

    getDealerwareWebComponentsModule().controller('CollectionListDirectiveController', CollectionListDirectiveController);


    export class CollectionListDirective implements ng.IDirective {

        public restrict         : string    =   'E';
        public controller       : any       =   'CollectionListDirectiveController';
        public controllerAs     : string    =   'collectionListController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            name: '=',
            title: '@',
            collection: '=',
            columns: '=',
            hideHeader: '=',
            muteNonDefaultRows: '=',
            defaultRowKey: '@',
            hideSinglePagePager: '=',
            showLoadAll: '=',
            showExportCsv: '=',
            exportFilePrefix: '=',
            exportColumns: '=',
            onLoadingStart: '&',
            onLoadingSuccess: '&',
            onLoadingError: '&',
            onSort: '&',
            parentController: '=?',
            rowClasses: '&?',
            hideRow: '&?'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/collection_list/collection_list_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCollectionList", () => new CollectionListDirective());
}
